function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { serviceCostModel } from '.';
export let StagesValueType = /*#__PURE__*/function (StagesValueType) {
  StagesValueType["Percent"] = "percent";
  StagesValueType["Amount"] = "amount";
  return StagesValueType;
}({});
export let StagesTerms = /*#__PURE__*/function (StagesTerms) {
  StagesTerms["AutoFirst"] = "auto_first";
  StagesTerms["AllManual"] = "all_manual";
  return StagesTerms;
}({});
export class OneTimeInStagesModel {
  static fromDTO(dto) {
    return new OneTimeInStagesModel({
      valueType: dto.valueType,
      terms: dto.terms,
      stages: dto.stages.map(stage => ({
        stageNumber: stage.stageNumber,
        value: new Decimal(stage.value).div(100)
      }))
    });
  }
  static make(data) {
    return new OneTimeInStagesModel(data);
  }
  static makeStage(stageNumber, value) {
    return {
      stageNumber,
      value
    };
  }
  constructor(data) {
    this.data = data;
  }
  toDTO() {
    return {
      valueType: this.data.valueType,
      terms: this.data.terms,
      stages: this.data.stages.map(stage => ({
        stageNumber: stage.stageNumber,
        value: stage.value.mul(100).toNumber()
      }))
    };
  }
  numStages() {
    return this.data.stages.length;
  }
  hasInvalidStages(cost) {
    const stages = this.data.stages;
    if (stages.length === 0) return false;
    const valueType = this.data.valueType;
    const isPercentage = valueType === StagesValueType.Percent;
    if (stages.some(s => s.value.lte(0) || isPercentage && s.value.gte(100))) return true;
    if (cost) {
      const totalRate = serviceCostModel.price(cost);
      const isValueTypeDollars = valueType === StagesValueType.Amount;
      const totalSum = stages.reduce((acc, stage) => acc.plus(stage.value), new Decimal(0));
      const totalSumExceedsRate = totalSum.gt(isValueTypeDollars ? totalRate : new Decimal(100));
      return stages.some((stage, index) => {
        const isLast = index === stages.length - 1;
        if (valueType === StagesValueType.Percent && stage.value.gte(100)) return true;
        if (isValueTypeDollars && stage.value.gt(totalRate)) return true;
        if (valueType === StagesValueType.Percent && !isLast && totalSumExceedsRate) return true;
        if (isValueTypeDollars && !isLast && totalSumExceedsRate) return true;
        if (isLast && stage.value.eq(0)) return true;
        if (stage.value.eq(0)) return true;
        return false;
      });
    }
    return false;
  }
  stagesWithFinalAmount(cost) {
    const discountedPrice = serviceCostModel.applyDiscount(cost);
    const price = serviceCostModel.price(cost);
    const isPercentage = this.data.valueType === StagesValueType.Percent;
    const stages = this.data.stages.map(stage => _objectSpread(_objectSpread({}, stage), {}, {
      discountedFinalAmount: isPercentage ? discountedPrice.mul(stage.value).div(100).toDP(2) : stage.value.mul(discountedPrice).div(price).toDP(2),
      finalAmount: isPercentage ? price.mul(stage.value).div(100).toDP(2) : stage.value
    }));
    if (isPercentage) {
      stages[stages.length - 1].discountedFinalAmount = stages.slice(0, -1).reduce((acc, curr) => acc.minus(curr.discountedFinalAmount), discountedPrice);
      stages[stages.length - 1].finalAmount = stages.slice(0, -1).reduce((acc, curr) => acc.minus(curr.finalAmount), price);
    }
    return stages;
  }
  terms() {
    return this.data.terms;
  }
  valueType() {
    return this.data.valueType;
  }
  isAutoFirst() {
    return this.data.terms === StagesTerms.AutoFirst;
  }
  stages() {
    return this.data.stages;
  }
  setTerms(terms) {
    return new OneTimeInStagesModel(_objectSpread(_objectSpread({}, this.data), {}, {
      terms
    }));
  }
  setStages(stages) {
    return new OneTimeInStagesModel(_objectSpread(_objectSpread({}, this.data), {}, {
      stages
    }));
  }
  setValueType(valueType) {
    return new OneTimeInStagesModel(_objectSpread(_objectSpread({}, this.data), {}, {
      valueType
    }));
  }
}